import { Link } from 'react-router-dom';

export default function EcommerceCTA() {
  return (
    <section className="py-20 lg:py-24 relative overflow-hidden">
      <div className="absolute inset-0">
        <img
          src="https://readdy.ai/api/search-image?query=aerial%20view%20of%20a%20busy%20modern%20fulfillment%20warehouse%20with%20neatly%20organized%20product%20shelves%20and%20packages%20ready%20for%20shipping%2C%20warm%20industrial%20lighting%2C%20organized%20ecommerce%20operations%2C%20cinematic%20wide%20angle%20photography%2C%20rich%20warm%20amber%20tones%2C%20no%20text%2C%20high%20contrast%2C%20photorealistic&width=1920&height=700&seq=ecom-cta-bg-01&orientation=landscape"
          alt=""
          className="w-full h-full object-cover object-top"
          aria-hidden="true"
        />
        <div className="absolute inset-0 bg-black/60" />
      </div>

      <div className="relative z-10 max-w-3xl mx-auto px-6 lg:px-8 text-center">
        <span className="inline-block text-sm font-semibold text-orange-400 uppercase tracking-widest mb-5">
          Ready to Scale Your Store?
        </span>
        <h2 className="text-3xl lg:text-4xl font-black text-white mb-5 leading-tight">
          Stop Guessing. Start Selling with{' '}
          <span className="text-orange-400">AI Ads for Ecommerce</span>
        </h2>
        <p className="text-base text-stone-300 mb-8 leading-relaxed max-w-xl mx-auto">
          Join <strong className="text-white">30,000+ ecommerce store owners</strong> who use AdForge to run
          better <strong className="text-white">ecommerce advertising</strong> — without agencies,
          without experience, and without wasting budget.
        </p>

        <div className="flex flex-col sm:flex-row items-center justify-center gap-4 mb-6">
          <Link
            to="/signup"
            className="px-8 py-4 bg-orange-500 hover:bg-orange-600 text-white font-bold text-base rounded-xl transition-all duration-200 whitespace-nowrap cursor-pointer"
          >
            Generate Your First Ad — It&apos;s Free
          </Link>
          <Link
            to="/pricing"
            className="px-8 py-4 bg-white/10 hover:bg-white/20 border border-white/20 text-white font-semibold text-base rounded-xl transition-all duration-200 whitespace-nowrap cursor-pointer"
          >
            View Pricing
          </Link>
        </div>

        <p className="text-xs text-stone-400">
          No credit card required &middot; Cancel anytime
        </p>

        <div className="mt-10 flex flex-wrap items-center justify-center gap-6">
          {[
            { icon: 'ri-facebook-circle-fill', label: 'Facebook Ads for Ecommerce' },
            { icon: 'ri-google-fill', label: 'Google Shopping Ads' },
            { icon: 'ri-instagram-fill', label: 'Instagram Ads' },
            { icon: 'ri-tiktok-fill', label: 'TikTok Ads' },
          ].map((p) => (
            <div key={p.label} className="flex items-center gap-2 text-stone-400">
              <div className="w-5 h-5 flex items-center justify-center">
                <i className={`${p.icon} text-base`} />
              </div>
              <span className="text-xs font-medium whitespace-nowrap">{p.label}</span>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
